import WkPostSelect from './wk_post_select'

export default {
  install: (Vue) => {
    Vue.component('wk-post-select', WkPostSelect)
  }
}